import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

/**
 * Reusable contact form fields component
 * Used in both Add and Edit contact dialogs
 */
export const ContactFormFields = ({ data, onChange, prefix = '' }) => {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const getId = (field) => prefix ? `${prefix}-${field}` : field;
  const getTestId = (field) => prefix ? `${prefix}-contact-${field}` : `new-contact-${field}`;

  return (
    <div className="grid grid-cols-2 gap-4 py-4">
      <div className="col-span-2">
        <Label htmlFor={getId('email')}>Email Address *</Label>
        <Input
          id={getId('email')}
          type="email"
          value={data.email}
          onChange={(e) => handleChange('email', e.target.value)}
          placeholder="email@example.com"
          className="mt-1.5"
          data-testid={getTestId('email')}
        />
      </div>
      <div>
        <Label htmlFor={getId('first_name')}>First Name</Label>
        <Input
          id={getId('first_name')}
          value={data.first_name}
          onChange={(e) => handleChange('first_name', e.target.value)}
          placeholder="John"
          className="mt-1.5"
          data-testid={getTestId('first-name')}
        />
      </div>
      <div>
        <Label htmlFor={getId('last_name')}>Last Name</Label>
        <Input
          id={getId('last_name')}
          value={data.last_name}
          onChange={(e) => handleChange('last_name', e.target.value)}
          placeholder="Smith"
          className="mt-1.5"
          data-testid={getTestId('last-name')}
        />
      </div>
      <div className="col-span-2">
        <Label htmlFor={getId('business_name')}>Business Name</Label>
        <Input
          id={getId('business_name')}
          value={data.business_name}
          onChange={(e) => handleChange('business_name', e.target.value)}
          placeholder="Smith Plumbing Ltd"
          className="mt-1.5"
          data-testid={getTestId('business-name')}
        />
      </div>
      <div>
        <Label htmlFor={getId('phone_number')}>Phone Number</Label>
        <Input
          id={getId('phone_number')}
          value={data.phone_number}
          onChange={(e) => handleChange('phone_number', e.target.value)}
          placeholder="07700 900123"
          className="mt-1.5"
          data-testid={getTestId('phone')}
        />
      </div>
      <div>
        <Label htmlFor={getId('company_phone_number')}>Company Phone</Label>
        <Input
          id={getId('company_phone_number')}
          value={data.company_phone_number}
          onChange={(e) => handleChange('company_phone_number', e.target.value)}
          placeholder="0207 123 4567"
          className="mt-1.5"
          data-testid={getTestId('company-phone')}
        />
      </div>
      <div className="col-span-2">
        <Label htmlFor={getId('address')}>Address</Label>
        <Input
          id={getId('address')}
          value={data.address}
          onChange={(e) => handleChange('address', e.target.value)}
          placeholder="123 Main Street"
          className="mt-1.5"
          data-testid={getTestId('address')}
        />
      </div>
      <div>
        <Label htmlFor={getId('location')}>City/Town</Label>
        <Input
          id={getId('location')}
          value={data.location}
          onChange={(e) => handleChange('location', e.target.value)}
          placeholder="London"
          className="mt-1.5"
          data-testid={getTestId('location')}
        />
      </div>
      <div>
        <Label htmlFor={getId('postcode')}>Postcode</Label>
        <Input
          id={getId('postcode')}
          value={data.postcode}
          onChange={(e) => handleChange('postcode', e.target.value)}
          placeholder="SW1A 1AA"
          className="mt-1.5"
          data-testid={getTestId('postcode')}
        />
      </div>
      <div>
        <Label htmlFor={getId('category')}>Category/Trade</Label>
        <Input
          id={getId('category')}
          value={data.category}
          onChange={(e) => handleChange('category', e.target.value)}
          placeholder="Plumber"
          className="mt-1.5"
          data-testid={getTestId('category')}
        />
      </div>
      <div>
        <Label htmlFor={getId('website')}>Website</Label>
        <Input
          id={getId('website')}
          value={data.website}
          onChange={(e) => handleChange('website', e.target.value)}
          placeholder="www.example.com"
          className="mt-1.5"
          data-testid={getTestId('website')}
        />
      </div>
    </div>
  );
};

export default ContactFormFields;
